import CampaignsList from './CampaignsList';
import CampaignsItem from './CampaignsItem';

export {
  CampaignsList,
  CampaignsItem,
};



// WEBPACK FOOTER //
// ./src/components/Campaigns/index.js